import React from 'react';
import { Box, Link } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useQuery } from '@apollo/client';
import { colorBlue } from '../../layout/css/colors';
import { newPartnerHubModalStyle } from './NewPartnerHubModal.styles';
import { useUserToken } from '../../hooks/useUserToken';
import { GET_PROPERTY_MIGRATION_STATUS } from './NewPartnerHubModel.gql';


const LINK_TO_NEW_PARTNERHUB_PORTAL = (process.env.REACT_APP_LODGELINK_MIGRATION_INFO_LINK ?? "http://localhost:8004")



const NewPartnerHubModal = () => {

    const { token: userToken } = useUserToken();

    const { data } = useQuery(GET_PROPERTY_MIGRATION_STATUS, {
        variables: { token: userToken.token },
    });
    const migrationStatus = data?.PartnerHubQueries.getPropertyMigrationStatus;
    
    return (
        ( migrationStatus === "SCHEDULED" && <Box sx={newPartnerHubModalStyle}>
            <InfoOutlinedIcon fontSize='small' sx={{color: colorBlue}}/>
            The new Partnerhub is almost here and we&apos;ll move you over automatically
            <Link href={LINK_TO_NEW_PARTNERHUB_PORTAL} sx={{color: 'black'}}>Learn More</Link>
        </Box>
        )
    )
};


export default NewPartnerHubModal